import ActionNode from './ActionNode'

class ActionNodeWait extends ActionNode {
  constructor(model) {
    super(model)
    this.text = model.value.text
    this.icon = {
      ...this.icon,
      name: 'wait'
    }
  }

  changeValue(data) {
    this.value = data
    this.text = data.text
  }
}

export default ActionNodeWait



// WEBPACK FOOTER //
// ./src/utils/models/node/ActionNodeWait.js